import React from 'react'

import Card from '@/components/card/card'

const config = {
  className: 'related-list-card',
  minicard: true,
  hasNoImage: false,
  hasUnderline: true,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: false,
  hasDate: false,
}

export const RelatedListCard = ({ item }) => <Card item={item} {...config} />
